module.exports = __webpack_public_path__ + "img/ZKGW1000.ea2e6799.png";